import React from 'react';
import AppBar from './components/AppBarComponent';
import Display from './components/Display';
import DisplayList from './components/DisplayList';
import DisplayListByDate from './components/DisplayListByDate';
import Form from './components/Form';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline, Container } from '@material-ui/core';
import theme from './theme';
import ToDos from './components/ToDos';
import ResponsiveAppBar from './components/ResponsiveAppBar';
import october1 from './data/october1';
import october2 from './data/october2';
import sample from './data/sample'
import MonthlyCalendar from './components/Calendar/MonthlyCalendar';
import Home from './components/Home';

function App() {
  // what is my task?
  // all state is in app
  // including the active component
  // render the active component

  //
  //  SET UP STATE
  //
  const initState = october2;
  const [active, setActive] = React.useState('display');
  const [days, setDays] = React.useState(initState);
  const [form, setForm] = React.useState({
    id: -1,
    classRoom: '',
    entry: '',
    date: '',
    startTime: '',
    endTime: ''
  })

  //
  //  SET UP CALLBACKS
  //

  // this one is for form handling...
  const handleInputChange = name => event => {
    setForm({ ...form, [name]: event.target.value })
  }

  const resetForm = () => {
    setForm({
      id: -1,
      classRoom: '',
      entry: '',
      date: '',
      startTime: '',
      endTime: ''
    });
  }

  const handleCancelEntry = event => {
    event.preventDefault();
    resetForm();
    setActive('display');
  }

  const handleSubmitEntry = event => {

    // not submit but save!!!!

    // with controlled form we do not need to get values at all...
    // all our values are in our form state ...

    // get our values from the form
    // if id < 0 then new, else old
    // call the right method 

    event.preventDefault();
    // const form = event.target;

    // const entry = form.elements.entry.value;
    // const date = form.elements.date.value;
    // const startTime = form.elements.startTime.value;
    // const endTime = form.elements.endTime.value;
    // // console.log(date, startTime, endTime);

    if (form.id < 0) {
      addNewDate();
    } else {
      updateDate();
    }

    resetForm();

    setActive('display');
  }

  const addNewDate = () => {
    let ids = days.map(day => day.id);
    let max = ids.sort().reverse()[0];

    console.log('ids', ids, 'max', max);

    const newId = max ? max + 1 : 1;

    const newDay = {
      id: newId,
      classRoom: form.classRoom,
      entry: form.entry,
      date: form.date,
      startTime: form.startTime,
      endTime: form.endTime
    }

    setDays([...days, newDay]);
  }

  const updateDate = () => {
    const updatedDate = {
      id: form.id,
      classRoom: form.classRoom,
      entry: form.entry,
      date: form.date,
      startTime: form.startTime,
      endTime: form.endTime
    }

    const removed = days.filter(day => day.id !== form.id);
    setDays([...removed, updatedDate])
  }

  const handleToggle = active => event => {
    setActive(active);
  }

  const handleEdit = id => event => {
    let day = days.find(day => day.id === id);
    setForm(day);
    setActive('form');
  }

  const handleDelete = id => event => {
    let removed = days.filter(day => day.id !== id);
    setDays([...removed]);
  }

  const responsiveAppBar = false;
  const myAppBar = true;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {responsiveAppBar && <ResponsiveAppBar />}
      {myAppBar && <AppBar active={active} onToggle={handleToggle} />}
      <main>
        <Container>
          {active === 'form' &&
            <Form
              day={form}
              onInputChange={handleInputChange}
              onSubmitEntry={handleSubmitEntry}
              onCancel={handleCancelEntry}
            />
          }
          {
            active === 'display' &&
            <DisplayListByDate
              days={days}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          }
          {
            active === 'home' &&
            <Home onToggle={handleToggle} />
          }
          {active === 'todos' && <ToDos />}
          {active === 'calendar' && <MonthlyCalendar /> }
        </Container>

      </main>
    </ThemeProvider>
  );
}

export default App;
